import { useState } from "react";

export default function NavBar() {
  const [navbar, setNavbar] = useState(false);

  return (
    <nav className="bg-[#751efe] border-gray-200 lg:px-10 sm:px-4 lg:py-0 py-2.5">
      <div className="justify-between px-4 mx-auto lg:max-w-7xl md:items-center md:flex md:px-8">
        <div>
          <div className="flex items-center justify-between py-3 md:py-5 md:block">
            <a
              href="https://www.globalmentor.exchange/"
              target={"_blank"}
              className="flex items-center"
            >
              <img src="./assets/logoG.png" className="w-[230px]" alt />
            </a>
            <div className="md:hidden">
              <button
                className="p-2 text-gray-700 rounded-md outline-none focus:border-gray-400 focus:border"
                onClick={() => setNavbar(!navbar)}
              >
                {navbar ? (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="w-6 h-6 text-white"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path
                      fillRule="evenodd"
                      d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                      clipRule="evenodd"
                    />
                  </svg>
                ) : (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="w-6 h-6  text-white"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    strokeWidth={2}
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M4 6h16M4 12h16M4 18h16"
                    />
                  </svg>
                )}
              </button>
            </div>
          </div>
        </div>
        <div>
          <div
            className={`flex-1 justify-self-center pb-3 mt-8 md:block md:pb-0 md:mt-0 ${
              navbar ? "block" : "hidden"
            }`}
          >
            <ul className="flex flex-col p-4 mt-4 md:flex-row md:space-x-8 md:mt-0 md:text-sm md:font-medium">
              <li>
                <a
                  href="#roadmap"
                  className="block py-2 pl-3 pr-4 text-white rounded hover:text-white md:border-0  md:p-0 text-white"
                >
                  Roadmap
                </a>
              </li>

              <li>
                <a
                  href="#team"
                  className="block py-2 pl-3 pr-4 text-white rounded hover:text-white md:border-0  md:p-0 text-white"
                >
                  Team
                </a>
              </li>
              <li>
                <a
                  href="#token"
                  className="block py-2 pl-3 pr-4 text-white rounded hover:text-white md:border-0  md:p-0 text-white"
                >
                  Token
                </a>
              </li>
            </ul>
          </div>
        </div>
        <a
          href="http://arthurico.ramlogics.in"
          className="text-white lg:t px-8 py-2 md:block hidden border border-white rounded-md"
        >
          Buy Token
        </a>
      </div>
    </nav>
  );
}
